import React from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import uuid from 'react-uuid';
import emptyStateImage from 'assets/img/icn-empty-state.svg';
import ImagePlaceholder from 'assets/img/image-placeholder.jpg';
import { ucwords } from 'helper';
import * as actions from '../action';

function BusinessOperation({ newBusinessesInfo }) {
  const { quantity_matrix, ...detail } = _.get(newBusinessesInfo, 'attributes.details') || {};

  return (
    <div className="container-fluid card-section-content">
      <div className="card-body">
        {!_.isEmpty(newBusinessesInfo) ? (
          <React.Fragment>
            <div className="row bg-white pb-3">
              <div className="col-12">
                <div className="form-wrapper mb-3 p-3">
                  <table className="transaction-table table table-borderless table-sm mb-1">
                    <tbody>
                      <tr className="d-flex">
                        <td>
                          <span className="title" style={{ fontSize: '16px' }}>
                            BUSINESS OPERATIONS
                          </span>
                        </td>
                      </tr>
                      <tr>
                        <td className="text-dark" width="350">
                          Business Area  (in sq.m)
                        </td>
                        <td className="text-dark" width="1">
                          :
                        </td>
                        <td colSpan={4}>
                          <b>
                            {_.get(newBusinessesInfo, 'attributes.area_human')}
                          </b>
                        </td>
                      </tr>
                      <tr>
                        <td className="text-dark" width="350">
                          Total Floor Area (in sq.m)
                        </td>
                        <td className="text-dark" width="1">
                          :
                        </td>
                        <td colSpan={4}>
                          <b>
                            {_.get(newBusinessesInfo, 'attributes.floor_area_human')}
                          </b>
                        </td>
                      </tr>
                      <tr>
                        <td className="text-dark" width="350">
                          No. of Male Employees
                        </td>
                        <td className="text-dark" width="1">
                          :
                        </td>
                        <td colSpan={4}>
                          <b>
                            {_.get(
                              newBusinessesInfo,
                              'attributes.no_of_male_employees'
                            )}
                          </b>
                        </td>
                      </tr>
                      <tr>
                        <td className="text-dark" width="350">
                          No. of Female Employees
                        </td>
                        <td className="text-dark" width="1">
                          :
                        </td>
                        <td colSpan={4}>
                          <b>
                            {_.get(
                              newBusinessesInfo,
                              'attributes.no_of_female_employees'
                            )}
                          </b>
                        </td>
                      </tr>
                      <tr>
                        <td className="text-dark" width="350">
                          No. of Employees residing within Area
                        </td>
                        <td className="text-dark" width="1">
                          :
                        </td>
                        <td colSpan={4}>
                          <b>
                            {_.get(
                              newBusinessesInfo,
                              'attributes.no_of_employees_residing_manila'
                            )}
                          </b>
                        </td>
                      </tr>
                      <tr>
                        <td className="text-dark" width="350">
                          No. of Van
                        </td>
                        <td className="text-dark" width="1">
                          :
                        </td>
                        <td colSpan={4}>
                          <b>
                            {_.get(newBusinessesInfo, 'attributes.no_of_van')}
                          </b>
                        </td>
                      </tr>
                      <tr>
                        <td className="text-dark" width="350">
                          No. of Truck
                        </td>
                        <td className="text-dark" width="1">
                          :
                        </td>
                        <td colSpan={4}>
                          <b>
                            {_.get(newBusinessesInfo, 'attributes.no_of_truck')}
                          </b>
                        </td>
                      </tr>
                      <tr>
                        <td className="text-dark" width="350">
                          No. of Motorcycle
                        </td>
                        <td className="text-dark" width="1">
                          :
                        </td>
                        <td colSpan={4}>
                          <b>
                            {_.get(
                              newBusinessesInfo,
                              'attributes.no_of_motorcycle'
                            )}
                          </b>
                        </td>
                      </tr>
                      {Object.entries(detail).map(det => {
                        return (
                          <tr key={det}>
                            <td className="text-dark" width="350">
                              {ucwords(det[0].replace(/_/g, ' '))}
                            </td>
                            <td className="text-dark" width="1">
                              :
                            </td>
                            <td colSpan={4}>
                              <b>
                                {det[1] || 0}
                              </b>
                            </td>
                          </tr>
                        )
                      })}
                    </tbody>
                  </table>
                  {!_.isEmpty(quantity_matrix) ? (
                    Object.entries(quantity_matrix).map(([label, quantityMatrixData]) => {
                      return (
                        <React.Fragment>
                          <div key={uuid()} className='text-dark text-capitalize mx-2' style={{ fontSize: '0.875rem'}}>
                            {label || ''}
                          </div>
                          <div className='p-1'>
                            <div className='w-100 border rounded-lg my-2'>
                              <table className="table table-borderless table-sm table-striped table-hover mb-0">
                                <thead>
                                  <tr className='form-group'>
                                    <td className='col-4 text-center form-label border-right'>Unit</td>
                                    <td className='col-4 text-center form-label border-right'>Capacity</td>
                                    <td className='col-4 text-center form-label'>Number of Units</td>
                                  </tr>
                                </thead>
                                <tbody>
                                  {quantityMatrixData.map(item => {
                                      const multiplier = _.get(item, 'multiplier');
            
                                      return (
                                        <tr key={multiplier} className="top-border form-group">
                                          <td className="text-left form-label border-right">
                                            {_.get(item, 'unit')} 
                                          </td>
                                          <td className="text-left form-label border-right">
                                            {_.get(item, 'capacity')}
                                          </td>
                                          <td className="text-left form-label">
                                            {_.get(item, 'value', 0)}
                                          </td>
                                        </tr>
                                      )
                                  })}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </React.Fragment>
                      )
                    })
                  ) : ''}
                  <table>
                    <tbody>
                      <tr className="d-flex pt-3">
                        <td>
                          <span className="title" style={{ fontSize: '16px' }}>
                            BUSINESS ACTIVITIES
                          </span>
                        </td>
                      </tr>
                      <tr>
                        <td className="text-dark" width="350">
                          Activity Type
                        </td>
                        <td className="text-dark" width="1">
                          :
                        </td>
                        <td colSpan={4}>
                          <b>
                            {_.get(
                              newBusinessesInfo,
                              'attributes.activity_type'
                            )}
                          </b>
                        </td>
                      </tr>
                      <tr>
                        <td className="text-dark" width="350">
                          Tax Incentives from any Government Entity
                        </td>
                        <td className="text-dark" width="1">
                          :
                        </td>
                        <td colSpan={4}>
                          <b>
                            {_.get(
                              newBusinessesInfo,
                              'attributes.with_tax_incentives'
                            ) ? 'YES' : 'NO'}
                          </b>
                        </td>
                      </tr>
                      <tr>
                        <td className="text-dark" width="350">
                          Tax Incentives
                        </td>
                        <td className="text-dark" width="1">
                          :
                        </td>
                        <td colSpan={4}>
                          {_.isObject(_.get(newBusinessesInfo, 'tax_incentives_attachment_url')) ? (
                            <img
                              src={
                                !_.isObject(
                                  _.get(
                                    newBusinessesInfo,
                                    'tax_incentives_attachment_url'
                                  ) || ''
                                )
                                  ? _.get(
                                      newBusinessesInfo,
                                      'tax_incentives_attachment_url'
                                    ) || ImagePlaceholder
                                  : _.get(
                                      newBusinessesInfo,
                                      'tax_incentives_attachment_url.cdnUrl'
                                    ) || ImagePlaceholder
                              }
                              className="img-fluid"
                              role="presentation"
                              width="70%"
                              alt=""
                            />
                          ) : '-'}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </React.Fragment>
        ) : (
          <div className="d-flex align-items-center justitfy-content-center h-100">
            <div className="text-center mx-auto py-4">
              <img
                src={emptyStateImage}
                className="img-responsive image-wrapper mb-4 mt-3"
                alt="Empty State"
              />
              <p className="emp-title mb-0"> No Item Found </p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

BusinessOperation.propTypes = {
  newBusinessesInfo: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = () => ({});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(BusinessOperation);
